/**
 * Purchase Bill Print Templates
 *
 * pdfFormat is the PDF page size the template is laid out for.
 */

export const DEFAULT_PURCHASE_TEMPLATE = "compact";

export const PURCHASE_TEMPLATES = [
  {
    id: "compact",
    name: "Compact Slip (A5)",
    desc: "Half-sheet bill with readable text",
    pdfFormat: "a5"
  },
  {
    id: "standard",
    name: "Standard (A4)",
    desc: "Full-page purchase record with GST % per line",
    pdfFormat: "a4"
  }
];

/**
 * Find template metadata by id (falls back to the default)
 */
export function getPurchaseTemplateById(id) {
  return PURCHASE_TEMPLATES.find((t) => t.id === id)
    || PURCHASE_TEMPLATES.find((t) => t.id === DEFAULT_PURCHASE_TEMPLATE);
}
